import styled, { css } from 'styled-components';

import { BadgeProps } from './Badge';

const badgeColor = ({ theme, variant = 'grey' }: typeof BadgeContainer) => {
  switch (variant) {
    case 'grey':
    default:
      return css`
        background-color: ${theme.mosaiq.colors.grey};
        border-color: ${theme.mosaiq.colors.grey60};
        color: ${theme.mosaiq.colors.passive};
      `;
  }
};

export const BadgeContainer = styled.span<BadgeProps>`
  display: inline-block;
  border-radius: 1em;
  padding: ${({ theme }) => `${theme.mosaiq.spacing(0.25)}px ${theme.mosaiq.spacing(1)}px`};
  border: 1px solid;
  ${badgeColor}
  ${({ theme }) => theme.mosaiq.typography.title7()}
`;
